module.exports = [
  { code: 'USD', symbol: '$' },
  { code: 'CAD', symbol: 'C$' },
  { code: 'GBP', symbol: '£' },
  { code: 'EUR', symbol: '€' },
]
